function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.4375 17.8125C1.0923 17.8125 0.8125 17.5327 0.8125 17.1875V2.57812C0.8125 1.15652 1.96902 0 3.39062 0H14.5625C14.9077 0 15.1875 0.279844 15.1875 0.625V15C15.1875 15.3452 14.9077 15.625 14.5625 15.625C14.2173 15.625 13.9375 15.3452 13.9375 15V1.25H3.39062C2.65828 1.25 2.0625 1.84578 2.0625 2.57812V17.1875C2.0625 17.5327 1.7827 17.8125 1.4375 17.8125Z",
  fill: "current"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.5625 20H3.625C2.07418 20 0.8125 18.7383 0.8125 17.1875C0.8125 15.6367 2.07418 14.375 3.625 14.375H14.5625C14.9077 14.375 15.1875 14.6548 15.1875 15C15.1875 15.3452 14.9077 15.625 14.5625 15.625H3.625C2.76344 15.625 2.0625 16.3259 2.0625 17.1875C2.0625 18.0491 2.76344 18.75 3.625 18.75H14.5625C14.9077 18.75 15.1875 19.0298 15.1875 19.375C15.1875 19.7202 14.9077 20 14.5625 20Z",
  fill: "current"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14.5625 17.8125H3.625C3.2798 17.8125 3 17.5327 3 17.1875C3 16.8423 3.2798 16.5625 3.625 16.5625H14.5625C14.9077 16.5625 15.1875 16.8423 15.1875 17.1875C15.1875 17.5327 14.9077 17.8125 14.5625 17.8125Z",
  fill: "current"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M4.25 15.625C3.9048 15.625 3.625 15.3452 3.625 15V0.625C3.625 0.279844 3.9048 0 4.25 0C4.5952 0 4.875 0.279844 4.875 0.625V15C4.875 15.3452 4.5952 15.625 4.25 15.625Z",
  fill: "current"
});

var SvgHistorique = function SvgHistorique(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHistorique, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Historique.a5af6064.svg";
export { ForwardRef as ReactComponent };